import React, { useState } from "react";
import Button from '../../general/Button/Button';
import { useNavigate } from "react-router-dom";
import Alert from '../Alert/Alert';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import './CardAdmin.css';

const CardAdmin = ({ type, data, onDelete }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const navigate = useNavigate();
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState('');

  // Função para abrir o popup
  const handleOpenPopup = () => {
    if (!isPopupVisible) {
      setIsPopupVisible(true); // Abre o popup se não estiver visível
    }
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false); // Fecha o popup
  };

  const handleConfirmDeletion = () => {

    switch (type) {
      case "usuario":
        onDelete(data.uid, 'user');
        break;
      case "grupo":
        onDelete(data.uid, 'group');
        break;
      case "dashboard":
        onDelete(data.id, 'dashboard');
        break;
      default:
        console.log('default')
        break;
    }
    setAlertType('excluir'); // Definir tipo de alerta
    setAlertVisible(true);  // Exibir alerta
    setIsPopupVisible(false); // Fecha o popup após a exclusão
  };

  // Função para navegar para a página de edição
  const handleEdit = () => {
    // Condicionalmente navega para a página de edição dependendo do tipo
    switch (type) {
      case "dashboard":
        navigate(`/editarDash/${data.id}`); // Editar dashboard
        break;
      case "grupo":
        navigate(`/editarGrupo/${data.uid}`); // Editar grupo
        break;
      case "usuario":
        navigate(`/editarUsuario/${data.uid}`); // Editar usuario
        break;
      default:
        console.warn(`Tipo de card desconhecido: ${type}`);
        break;
    }
  };

  // Função para formatar o timestamp de lastLogin
  const formatLastLogin = (timestamp) => {
    if (!timestamp) return "Não disponível";
    const date = new Date(timestamp * 1000); // Converter segundos para milissegundos
    return date.toLocaleString(); // Exibir como data legível
  };

  // Função para renderizar os detalhes do card
  const renderCardDetails = (title, items) => (
    <>
      <strong className="card-admin-title">{title}</strong>
      <ul className="card-admin-list">
        {items.map((item, index) => (
          <li key={index} className="card-admin-list-item">{item}</li>
        ))}
      </ul>
    </>
  );

  const renderContent = () => {
    switch (type) {
      case "dashboard":
        return renderCardDetails(data.dashboardName, [
          `Usuários: ${data.readers?.length || 0}`,
          `Último Acesso: ${formatLastLogin(data.lastLogin?.seconds)}`
        ]);
      case "grupo":
        return renderCardDetails(data.groupName, [
          `Dashboards: ${data.numDashboards?.length || 0}`,
          `Usuários: ${data.readers?.length || 0}`,
          `Último Acesso: ${formatLastLogin(data.lastLogin?.seconds)}`
        ]);
      case "usuario":
        return renderCardDetails(data.userName, [
          `Email: ${data.userEmail}`,
          `Dashboards: ${data.dashboardsId?.length || 0}`,
          `Groups: ${data.groupsId?.length || 0}`,
          `Último Acesso: ${formatLastLogin(data.lastLogin?.seconds)}`
        ]);
      default:
        return <p>Tipo de card desconhecido.</p>;
    }
  };

  return (
    <>
      <div className="card-admin-card">
        <div className="card-admin-body">
          {renderContent()}
          <div className="card-admin-buttons">

            <Button
              type="submit"
              variant="delete"
              className="btn-delete"
              fullWidth
              onClick={handleOpenPopup}
            >
              Excluir
            </Button>
            <Button
              type="submit"
              variant="edit"
              className="btn-edit"
              fullWidth
              onClick={handleEdit}
            >
              Editar
            </Button>
          </div>
        </div>
      </div>

      {/* Exibindo o popup de confirmação quando o estado isPopupVisible for true */}
      {isPopupVisible && (
        <div className="confirmation-overlay">
          <ConfirmationPopup
            onClose={handleClosePopup}
            onConfirm={handleConfirmDeletion}
          />
        </div>
      )}

      {alertVisible && (
        <Alert
          type={alertType}
          onClose={() => setAlertVisible(false)}  // Fecha o alerta
        />
      )}
    </>
  );
};

export default CardAdmin;
